import { BaseIcon, type BaseIconProps } from '@fountain/ripple/icon';
import React, { forwardRef } from 'react';

// Source: images/change-icon-blue.svg.
export const ChangeIcon = forwardRef<SVGSVGElement, BaseIconProps>(
  function ChangeIcon(props, ref) {
    return (
      <BaseIcon
        ref={ref}
        viewBox="0 0 16 14"
        fill="currentColor"
        stroke="none"
        {...props}
      >
        <path d="M4 6L0 10L4 14V11H10.5C10.7761 11 11 10.7761 11 10.5V9.5C11 9.22386 10.7761 9 10.5 9H4V6ZM16 4L12.01 0V3H5.5C5.22386 3 5 3.22386 5 3.5V4.5C5 4.77614 5.22386 5 5.5 5H12.01V8L16 4Z" />
      </BaseIcon>
    );
  },
);
